import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import { useTranslation } from 'react-i18next';

const AddDeathCauseForm = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <input type="text" name="name" placeholder={t("death_cause")} required />
      <input type="text" name="matches" placeholder={t("nicknames_placeholder")} />
    </>
  );
}

const getBodyFromForm = (formData) => {
  const name    = formData.get("name");
  const matches = formData.get("matches");
  return JSON.stringify({ name, matches });
}

export const AddDeathCause = (props) => {
  return (
    <DataCollectionAdd
      collection="death_causes"
      getBodyFromForm={getBodyFromForm}
      formElements={AddDeathCauseForm}
      onSuccess={props.onSuccess}
      duplicateMsg="A death cause with that name already exists."
    />
  );
}

export default AddDeathCause;
